<template>
  <div class="enterprise">
    <el-form :model="queryInfo" class="ly-header__bg" label-width="100px">
      <el-form :model="queryInfo" class="ly-header__bg" label-width="100px">
        <el-form-item label="日期：">
          <data-time @dateChange="dateClick" />
        </el-form-item>
      </el-form>

      <el-form-item label="赋能行业：">
        <SelectTreeRadio
          :isTree="true"
          apiName="getIndustryList"
          :params="{ groupLabelType: '赋能行业标签组' }"
          resultType="values"
          storageKey="industryCategoryList"
          v-model="queryInfo.industryCategoryList"
          @input="e => labelTagChange('industryCategoryList', e, '赋能行业')"
        ></SelectTreeRadio>
      </el-form-item>

      <el-form-item label="领域类别：">
        <SelectTreeRadio
          :isTree="true"
          apiName="getIndustryList"
          :params="{ groupLabelType: '数智领域标签' }"
          resultType="values"
          storageKey="domainCategory"
          v-model="queryInfo.domainCategory"
          @input="e => labelTagChange('domainCategory', e, '领域类别')"
        ></SelectTreeRadio>
      </el-form-item>

      <el-form-item label="技术类别：">
        <SelectTreeRadio
          :isTree="true"
          apiName="getIndustryList"
          :params="{ groupLabelType: '数智技术标签' }"
          resultType="values"
          storageKey="solutionTechnology"
          v-model="queryInfo.solutionTechnology"
          @input="e => labelTagChange('solutionTechnology', e, '技术类别')"
        ></SelectTreeRadio>
      </el-form-item>

      <el-form-item label="产品类型：">
        <SelectTreeRadio
          :isTree="true"
          apiName="getDicRadioButton"
          :params="{ code: '021' }"
          resultType="values"
          vFeild="codeId"
          lFeild="codeName"
          storageKey="technicalCategory"
          v-model="queryInfo.productType"
          @input="e => labelTagChange('productType', e, '产品类型')"
        ></SelectTreeRadio>
      </el-form-item>

      <el-form-item label="筛选条件：" class="filterInfo">
        <el-tag
          closable
          v-for="(item, index) in tags"
          :key="index + item.name"
          @close="closeTag(index, item)"
        >
          {{ item.name }}：{{ item.field ? item.field : "不限" }}
          <span
            class="circle"
            v-if="item.hasOwnProperty('valLength') && item.valLength > 0"
            >+{{ item.valLength }}</span
          >
        </el-tag>
      </el-form-item>
    </el-form>

    <div class="ly-container__bg">
      <div class="ly_operation">
        <div class="left">
          <el-button type="primary" icon="jr-iconjr-icon-add" @click="addItem"
            >添加</el-button
          >

          <ImportFilePopup moduleName="产品类别" templateUrl="/template/产品类别.xlsx" buttonText="批量产品类别" popupTitle="批量新增产品类别"
                           templateName="产品类别" @uploadSuccess="search"/>

          <el-button @click="multiDelete">
            批量删除
            <i class="jr-iconjr-icon-delect" />
          </el-button>

          <popover @popoverClick="popoverClick" />

          <!-- <div class="upload_time">
            <div @click="caretText" class="caretTime">按上传时间</div>
            <div class="upload_time_icon">
              <i
                class="el-icon-caret-top"
                :class="[
                  queryInfo.columnName == 'create_time' && queryInfo.order == 0
                    ? 'isActiveTime'
                    : 'iconColor'
                ]"
                @click="caretTop"
              />
              <i
                class="el-icon-caret-bottom"
                :class="[
                  queryInfo.columnName == 'create_time' && queryInfo.order == 1
                    ? 'isActiveTime'
                    : 'iconColor'
                ]"
                @click="caretBottom"
              />
            </div>
          </div> -->
        </div>

        <MySearchInput
          placeholderTxt="请输入产业类别、技术、所在地、合作状态、企业等"
          v-model="queryInfo.queryConditions"
          @on-search="search"
          @on-clear="search"
          @on-enter="search"
        ></MySearchInput>
      </div>

      <el-table
        class="ly_table"
        :data="enterpriseTable"
        :header-cell-style="{ background: '#F5F6F7', color: '#363E4D' }"
        @selection-change="handleSelectionChange"
        :cell-style="set_cell_style"
        @sort-change="sortChange"
        style="width: 100%"
      >
        <template slot="empty">
          <img src="@/assets/img/table.png" alt="没有数据" srcset />
        </template>

        <el-table-column type="selection" width="55" align="center" />

        <el-table-column
          label="编号"
          prop="categoryCode"
          align="center"
          width="100"
        > </el-table-column>

        <el-table-column
          prop="companyDataIntegrity"
          label="数据完整度"
          sortable="custom"
          align="center"
          width="120"
        >
          <template v-slot="{ row }">
            <div @click="editItem(row)" style="cursor: pointer">
              <el-progress
                type="circle"
                :percentage="Number(row.dataIntegrity)"
                :stroke-width="12"
              ></el-progress>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="数据质量" prop="dataQuality" align="center"></el-table-column>

        <el-table-column label="产品名称" prop="categoryName" align="center"></el-table-column>

        <el-table-column
          label="赋能行业"
          align="center"
          prop="industryCategory"
        ></el-table-column>

        <el-table-column
          label="企业名称"
          align="center"
          prop="companyFullName"
        ></el-table-column>

        <el-table-column
          prop="updateTime"
          label="修改时间"
          align="center"
          width="100"
          :formatter="formatTime"
        ></el-table-column>

        <el-table-column
          prop="createName"
          label="创建人"
          align="center"
          width="80"
        ></el-table-column>

        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          width="120"
          :formatter="formatTime"
        ></el-table-column>

        <el-table-column label="操作" width="120" align="center">
          <template v-slot="{ row }">
            <button-table
              @buttonClick="editItem(row)"
              content="编辑"
              icon="jr-iconjr-icon-edit"
            />
            <button-table
              @buttonClick="deleteItem(row)"
              content="删除"
              icon="jr-iconjr-icon-delect"
            />
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 30, 50, 100, 200]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import DicCheckboxGroup from "@/components/DicCheckboxGroup.vue";
import Popover from "@/components/Popover.vue";
import ImportData from "@/components/ImportData.vue";
import ButtonTable from "@/components/ButtonTable.vue";
import DicTagButton from "@/components/DicTagButton.vue";
import DicRadioButton from "@/components/DicRadioButton.vue";
import CascaderArea from "@/components/CascaderAreaEnter.vue";
import {
  getCompanyList,
  deleteCompany,
  updateCompany
  // getPatentInformation
} from "@/api/enterprise";

import DataTime from "../Product/com/dataTime.vue";
import { exportData } from "@/utils/tool";
import { pagination } from "@/mixins/pagination";

// api
import { getProductClassify, deleteCategory } from "@/api/productClassify.js";

// 多级标签
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
import ImportFilePopup from "@/components/ImportFilePopup/index.vue";
export default {
  mixins: [pagination],
  components: {
    ImportFilePopup,
    ButtonTable,
    ImportData,
    DicRadioButton,
    DicTagButton,
    DicCheckboxGroup,
    CascaderArea,
    Popover,
    DataTime,
    SelectTreeRadio
  },

  data() {
    return {
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
        queryConditions: "",
        order: 1, // 0正序 1倒叙
        columnName: "create_time",
        industrialChainId: "", // 产业类别
        techId: [],
        fieldId: [],
        size: "", // 所选条数
        companyCode: [], // 公司编号
        industryCategoryList: [], //赋能行业数组字段
        domainCategory: [], // 领域类别
        solutionTechnology: [], // 技术类别
        productType: [], //产品类型
        years: null, // 年
        month: null, // 月
        day: null // 日
      },
      enterpriseTable: [],
      dialogType: "技术类别",
      editTableObj: {
        techId: [], // 技术类别
        techChildrenId: [], // 技术类别二级标签
        fieldChildrenId: [], // 领域类别二级标签
        fieldId: [] // 领域类别
      },
      company: {
        code: [], // 单选删除
        multiCode: [] // 多选删除
      },
      dialogVisible: false,
      gridData: [],
      tags: [
        {
          name: "赋能行业",
          tagName: "industryCategoryList",
          valLength: 0
        },
        {
          name: "领域类别",
          tagName: "domainCategory",
          valLength: 0
        },
        {
          name: "技术类别",
          tagName: "solutionTechnology",
          valLength: 0
        },
        {
          name: "产品类型",
          tagName: "productType",
          valLength: 0
        }
      ],
      enterpriseInfo: {
        companyLogo: "", // 公司logo
        companyFullName: "", // 公司全称
        companyOperationalStatus: "", // 运营状态
        companyName: "", // 公司名称
        companyShortName: "", // 公司简称
        companyWebsite: "", // 公司网址
        companyEstablishTime: "", // 成立时间
        companyDescribe: "", // 一句话介绍
        companyBriefIntroduction: "", // 公司简介
        socialSecurityNumber: "", // 社保人数
        industrialChainId: [], // 产业类别
        techId: [], // 技术类别
        fieldId: [], // 领域类别
        cooperationStatus: "", // 合作状态
        companyFinancingRounds: "", // 融资轮次
        isQianlima: "", // 千里马公司
        isUnicorn: "" // 独角兽公司
      },
      sortData: {},
      valueI: 0
    };
  },

  computed: {
    Authorization() {
      return sessionStorage.getItem("token");
    },
    enterpriseType() {
      return this.$route.params.enterpriseType;
    }
  },

  methods: {
    //添加
    addItem() {
      this.$router.push({
        name: "productClassifyInfo"
      });
    },
    fileClick() {
      this.search();
    },
    dateClick(obj) {
      if (obj.year == "0") {
        this.queryInfo.years = "";
        this.queryInfo.month = "";
        this.queryInfo.day = "";
        this.search();
      } else if (obj.month == "0") {
        this.queryInfo.years = obj.year + "";
        this.queryInfo.month = "";
        this.queryInfo.day = "";
        this.search();
      } else if (obj.day == "0") {
        this.queryInfo.years = obj.year + "";
        this.queryInfo.month = obj.month + "";
        this.queryInfo.day = "";
        this.search();
      } else {
        this.queryInfo.years = obj.year + "";
        this.queryInfo.month = obj.month + "";
        this.queryInfo.day = obj.day + "";
        this.search();
      }
    },
    popoverClick(val) {
      if (val === "all") {
        Object.assign(this.queryInfo, { companyCode: [], size: "" });
      } else if (val == 0 && this.queryInfo.companyCode.length) {
        Object.assign(this.queryInfo, {
          companyCode: this.queryInfo.companyCode
        });
      } else {
        Object.assign(this.queryInfo, { size: val });
      }

      exportData(
        this.queryInfo, // 后台需要的参数
        "/company/exportExcel", // 路径
        "application/msexcel", // 下载的文件类型
        this.search, // 下载完之后调查询方法
        "企业数据.xls"
      );
    },
    updateCode(val, tag) {
      this.$nextTick(() => {
        switch (tag) {
          case "领域":
            this.editTableObj.fieldChildrenId = val;
            break;

          case "技术":
            this.editTableObj.techChildrenId = val;
            break;

          default:
            break;
        }
      });
    },
    // 查询条件更变 recode
    labelTagChange(key, value, name) {
      const index = this.tags.findIndex(el => {
        return el.tagName === key;
      });

      if (index !== -1) {
        let tagItem = this.tags[index];

        if (tagItem.hasOwnProperty("valLength")) {
          this.setTagValue(tagItem, value, true);
        } else {
          this.setTagValue(tagItem, value, false);
        }

        this.search();
      } else {
        let tempObj = {
          name,
          tagName: key
        };

        if (Array.isArray(value)) {
          tempObj.valLength = 0;
        }

        this.tags.push(tempObj);
      }
    },
    setTagValue(tagItem, value, flag) {
      if (flag) {
        if (Array.isArray(value) && value.length) {
          this.$set(tagItem, "field", value[0]);
          tagItem.valLength = value.length - 1;
        } else {
          this.$set(tagItem, "field", "");
          tagItem.valLength = 0;
        }
      } else {
        if (value) {
          this.$set(tagItem, "field", value);
        } else {
          this.$set(tagItem, "field", "");
        }
      }
    },
    // tag标签关闭
    closeTag(index, item) {
      this.tags.splice(index, 1);

      if (item.hasOwnProperty("valLength")) {
        this.queryInfo[item.tagName] = [];
      } else {
        this.queryInfo[item.tagName] = "";
      }

      this.search();
    },
    // 查询
    async search() {
      const res = await getProductClassify(this.queryInfo);
      if (res.code === 200) {
        this.enterpriseTable = res.data.list;

        this.total = res.data.total;
      }
    },
    // 多选
    handleSelectionChange(val) {
      this.company.multiCode = val.map(item => {
        return item.categoryCode;
      });

      this.queryInfo.companyCode = val.map(item => {
        return item.categoryCode;
      });
    },
    // 多选删除
    multiDelete(e) {
      if (this.company.multiCode.length > 1) {
        this._deleteCompany(this.company.multiCode);
      } else {
        this.$message.error("批量删除必须大于一条");
      }

      let target = e.target;
      if (target.nodeName === "SPAN") {
        // span 标签
        target = e.target.parentNode;
      }
      target.blur();
    },
    // 单选删除
    deleteItem(row) {
      this.company.code.push(row.categoryCode);

      this._deleteCompany(this.company.code);
    },
    _deleteCompany(params) {
      this.$confirm("确认删除吗 ?", "提示")
        .then(async () => {
          const res = await deleteCategory(params);

          if (res.code === 200) {
            this.$message.success("删除成功");
            this.search();
          }
        })
        .catch(() => {});
    },
    // 领域技术类别
    set_cell_style({ row, column, rowIndex, columnIndex }) {
      if (column.label === "领域类别" || column.label === "技术类别") {
        return "cursor:pointer;";
      }
    },
    // 字符串格式化成数组
    formatString(val) {
      if (!val) {
        return [];
      } else if (!val.length) {
        return val;
      } else {
        return val.split(",");
      }
    },
    // 编辑
    editItem(row) {
      this.$router.push({
        path: "/productClassify/productClassifyInfo",
        query: {
          productCode: row.categoryCode,
          enterpriseType: 1,
          queryInfo: this.queryInfo,
          id: row.id,
          headTabActive: 0,
          type: 2
        }
      });
    },
    // 点击文字切换正倒序
    caretText() {
      switch (this.valueI) {
        case 0:
          this.queryInfo.columnName = "create_time";
          this.queryInfo.order = 1;
          this.valueI++;
          break;
        case 1:
          this.queryInfo.columnName = "create_time";
          this.queryInfo.order = 0;
          this.valueI++;
          break;
        case 2:
          this.queryInfo.columnName = "create_time,update_time";
          this.queryInfo.order = 1;
          this.valueI = 0;
          break;
      }
      this.search();
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      );
    },
    // 正序
    caretTop() {
      // this.queryInfo.order = 0;
      // this.search();
    },
    // 倒序
    caretBottom() {
      // this.queryInfo.order = 1;
      // this.search();
    },
    // 数据完整度排序
    sortChange(column) {
      this.pageNum = 1;
      if (column.prop === "companyDataIntegrity") {
        this.queryInfo.columnName = "company_data_integrity";
        if (column.order === "ascending") {
          this.queryInfo.order = 0;
        } else if (column.order === "descending") {
          this.queryInfo.order = 1;
        } else {
          this.queryInfo.order = 1;
          this.queryInfo.columnName = "create_time,update_time";
        }
      } else if (column.prop === "companyCode") {
        this.queryInfo.columnName = "company_code";
        if (column.order === "ascending") {
          this.queryInfo.order = 0;
        } else if (column.order === "descending") {
          this.queryInfo.order = 1;
        } else {
          this.queryInfo.order = 1;
          this.queryInfo.columnName = "create_time,update_time";
        }
      }
      this.search();
    },
    searchArae(val) {
      this.queryInfo.companyCountry = val.country;

      this.queryInfo.companyProvince = val.province;

      if (
        val.city != "北京" &&
        val.city != "天津" &&
        val.city != "上海" &&
        val.city != "重庆"
      ) {
        this.queryInfo.companyCity = val.city;
      }

      this.search();
    }
  },
  async created() {
    this.search();
  }
};
</script>

<style lang="less" scoped>
.enterprise {
  /deep/ .el-input-group__append {
    background: #1e9fff;
    color: #fff;
    border: 1px solid #1e9fff;
  }
  .caretTime:hover {
    cursor: pointer;
  }
}
/deep/ .filterInfo .el-form-item__content {
  padding: 0;
}
/deep/ .el-image__inner {
  border-radius: 5px;
}
.isActiveTime {
  color: #1e9fff !important;
}
.iconColor {
  color: #c0c4cc !important;
}
</style>
